import { int1 } from "./pages-ru/int1"
import { int2 } from "./pages-ru/int2"
import { int3 } from "./pages-ru/int3"
import { int4 } from "./pages-ru/int4"
import { int5 } from "./pages-ru/int5"
import { int6 } from "./pages-ru/int6"
import { int7 } from "./pages-ru/int7"
import { int8 } from "./pages-ru/int8"
import { int9 } from "./pages-ru/int9"
import { int10 } from "./pages-ru/int10"
import { int11 } from "./pages-ru/int11"
import { int12 } from "./pages-ru/int12"
import { int13 } from "./pages-ru/int13"
import { int14 } from "./pages-ru/int14"
import { int15 } from "./pages-ru/int15"
import { int16 } from "./pages-ru/int16"
import { int17 } from "./pages-ru/int17"
import { int18 } from "./pages-ru/int18"
import { int19 } from "./pages-ru/int19"
import { int20 } from "./pages-ru/int20"
import { int21 } from "./pages-ru/int21"
import { int22 } from "./pages-ru/int22"
import { int23 } from "./pages-ru/int23"
import { int24 } from "./pages-ru/int24"
import { int25 } from "./pages-ru/int25"
import { int26 } from "./pages-ru/int26"


export const contentINTru = [
    { key: "int1", html: int1 },
    { key: "int2", html: int2 },
    { key: "int3", html: int3 },
    { key: "int4", html: int4 },
    { key: "int5", html: int5 },
    { key: "int6", html: int6 },
    { key: "int7", html: int7 },
    { key: "int8", html: int8 },
    { key: "int9", html: int9 },
    { key: "int10", html: int10 },
    { key: "int11", html: int11 },
    { key: "int12", html: int12 },
    { key: "int13", html: int13 },
    { key: "int14", html: int14 },
    { key: "int15", html: int15 },
    { key: "int16", html: int16 },
    { key: "int17", html: int17 },
    { key: "int18", html: int18 },
    { key: "int19", html: int19 },
    { key: "int20", html: int20 },
    { key: "int21", html: int21 },
    { key: "int22", html: int22 },
    { key: "int23", html: int23 },
    { key: "int24", html: int24 },
    { key: "int25", html: int25 },
    { key: "int26", html: int26 },
]